import React from "react";
import get from "lodash/get";
import map from "lodash/map";
import forEach from "lodash/forEach";
import { connect } from "react-redux";
import {
  Alert,
  Button,
  Col,
  Form,
  Icon,
  Input,
  message,
  Row,
  Select,
} from "antd";
import { withNamespaces } from "react-i18next";
import { v4 as uuidv4 } from "uuid";

import classes from "./SamlConfig.css";

import {patchSamlConfigRequest, samlConfigProperties} from "../../api/requests";
import { logout } from "../../reducers/user/actions";

const { Option } = Select;

class EditConfigForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      configData: {},
      isLoading: false,
      samlSettingsKeys: [],
      samlSettingsValues: {},
      samlRoleKeys: [],
      samlRoleValues: {},
      randomizationData: null,
      errorMessage: null,
      samlEntityId: null,
      samlAcsUrl: null,
      isLoadingData: false,
    };
  }


  componentDidMount() {
    this.setData();
    this.getSamlConfig(get(this.props.configData, 'type_name', null));
  }

  getSamlConfig = async (samlType) => {
    if (!samlType){
      return
    };
    this.setState({
      isLoadingData: true,
    });
    try {
      const { data } = await samlConfigProperties(samlType);
      this.setState({
        samlEntityId: get(data, 'entity_id', null),
        samlAcsUrl: get(data, 'acs_url', null),
      });
    } catch (e) {
      console.log(e);
    }
    this.setState({
      isLoadingData: false,
    });
  };

  setData = () => {
    const { configData } = this.props;

    const samlSettingsKeys =
      configData.fields_map && Object.keys(configData.fields_map).length > 0
        ? [...map(Object.keys(configData.fields_map), () => uuidv4())]
        : [uuidv4()];

    const samlRoleKeys =
      configData.role_map && Object.keys(configData.role_map).length > 0
        ? [...map(Object.keys(configData.role_map), () => uuidv4())]
        : [uuidv4()];

    const samlSettingsValues = {};
    forEach(samlSettingsKeys, (key, i) => {
      if (
        Object.keys(configData.fields_map) &&
        Object.keys(configData.fields_map)[i]
      ) {
        const fieldKey = Object.keys(configData.fields_map)[i];

        samlSettingsValues[key] = {
          attributeName: fieldKey,
          attributeValue: configData.fields_map[fieldKey],
        };
      }
    });

    const samlRoleValues = {};
    forEach(samlRoleKeys, (key, i) => {
      if (
        Object.keys(configData.role_map) &&
        Object.keys(configData.role_map)[i]
      ) {
        const fieldKey = Object.keys(configData.role_map)[i];

        samlRoleValues[key] = {
          attributeName: fieldKey,
          attributeValue: configData.role_map[fieldKey],
        };
      }
    });

    this.setState({
      samlSettingsKeys,
      samlSettingsValues,
      samlRoleKeys,
      samlRoleValues,
    });
  };

  removeSamlGroup = (key) => {
    const samlSettingsKeys = [...this.state.samlSettingsKeys].filter(
      (k) => key !== k
    );

    this.setState({
      samlSettingsKeys,
    });
  };

  addSamlGroup = () => {
    this.setState({
      samlSettingsKeys: [...this.state.samlSettingsKeys, uuidv4()],
    });
  };

  removeSamlRoleGroup = (key) => {
    const samlRoleKeys = [...this.state.samlRoleKeys].filter((k) => key !== k);

    this.setState({
      samlRoleKeys,
    });
  };

  addSamlRoleGroup = () => {
    this.setState({
      samlRoleKeys: [...this.state.samlRoleKeys, uuidv4()],
    });
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    this.setState({
      errorMessage: null,
    });
    this.props.form.validateFields(async (err, values) => {
      if (!err) {
        const data = { ...values };
        delete data["samlGroup"];
        delete data["samlRoleGroup"];
        data["fields_map"] = {};
        data["role_map"] = {};

        if (values["samlGroup"]) {
          Object.keys(values["samlGroup"]).map((key) => {
            const group = values["samlGroup"][key];
            let attributeName = values["samlGroup"][key].attributeName || null;
            data["fields_map"][attributeName] =
              values["samlGroup"][key].attributeValue || null;
          });
        }
        if (values["samlRoleGroup"]) {
          Object.keys(values["samlRoleGroup"]).map((key) => {
            const group = values["samlRoleGroup"][key];
            let attributeName =
              values["samlRoleGroup"][key].attributeName || null;
            data["role_map"][attributeName] =
              values["samlRoleGroup"][key].attributeValue || null;
          });
        }

        console.log(data);

        try {
          await patchSamlConfigRequest(this.props.configData.id, data);
          message.success(this.props.i18n.t("Saved"));
          this.props.onSubmit();
        } catch (e) {
          this.setState({
            errorMessage: JSON.stringify(get(e, "response.data.errors")),
          });
          message.error(this.props.i18n.t("Error"));
          console.log(e);
        }
      }
    });
  };

  render() {
    const {
      isLoading,
      samlSettingsKeys,
      samlRoleKeys,
      errorMessage,
    } = this.state;
    const { configData, isDisabled, isEditable = true } = this.props;
    const { getFieldDecorator, getFieldValue } = this.props.form;

    return (
      <div className={classes.formWrapper}>
        <Form onSubmit={this.handleSubmit}>
          <div style={{ marginBottom: "15px" }}>
            <Row gutter={8}> <Col lg={24}>
              {get(this.state, 'samlEntityId') && (
                <div>
                  <h5>{this.props.i18n.t(
                    "NamespaceEditSamlConfig:Basic SAML configuration"
                  )}</h5>
                  {get(configData, "type_name", null) === 'azure' && (<p className={classes.grayComment}><i>{this.props.i18n.t(
                    "NamespaceEditSamlConfig:To set up Single Sign-on with SAML for your Azure enterprise application please use these Service Provider attributes. (config step 1)"
                  )}</i></p>)}
                  <br/>
                  <h6>{this.props.i18n.t(
                    "NamespaceEditSamlConfig:Saml Entity Id"
                  )}:</h6>
                  <div>
                    <p className={classes.spanStyle}>{this.state['samlEntityId']}</p>
                  </div>
                  {get(configData, "type_name", null) === 'azure' && (
                    <div><p className={classes.grayComment}><i>{this.props.i18n.t(
                    "NamespaceEditSamlConfig:Paste into the \"Identifier (Entity ID)\" in Azure. Format: \"[api_url]/sp/metadata\". Can also be used as the SP metadata url."
                    )}</i></p></div>)}
                </div>
              )}

              {get(this.state, 'samlAcsUrl') && (
                <div>
                  <br/>
                  <h6>{this.props.i18n.t(
                    "NamespaceEditSamlConfig:Saml ACS URL"
                  )}:</h6>
                  <div>
                    <p className={classes.spanStyle}>{this.state['samlAcsUrl']}</p>
                  </div>

                  {get(configData, "type_name", null) === 'azure' && (
                    <div><p className={classes.grayComment}><i>{this.props.i18n.t(
                      "NamespaceEditSamlConfig:Paste into the \"Reply URL\" in Azure. Format: \"[api_url]/saml/[saml_type]/acs\". Can also be used as the SP metadata url."
                    )}</i></p></div>)}
                </div>
              )}

              <hr/>

              <Form.Item
                label={this.props.i18n.t(
                  "NamespaceEditSamlConfig:Metadata URL"
                )}
              >
                <div>
                  {getFieldDecorator("metadata_url", {
                    initialValue: get(configData, "metadata_url", null)
                  })(
                    <Input
                      disabled={!isEditable || isDisabled}
                      placeholder={this.props.i18n.t(
                        "NamespaceEditSamlConfig:Metadata URL"
                      )}
                      allowClear
                    />
                  )}
                </div>
                {get(configData, "type_name", null) === 'azure' && (<div>
                  <p className={classes.grayComment}><i>{this.props.i18n.t(
                    "NamespaceEditSamlConfig:Once the enterprise app single sign-on is configured in Azure, please copy the \"App Federation Metadata Url\" from the SAML Certificates (config step 3)."
                  )}</i></p>
                </div>)}
              </Form.Item> </Col>

              <Col lg={24}> <Form.Item
                label={this.props.i18n.t("NamespaceEditSamlConfig:Type Name")}
              >
                <div>
                  {getFieldDecorator("type_name", {
                    initialValue: get(configData, "type_name", null),
                    rules: [
                        {
                          required: true,
                          message: this.props.i18n.t("Required"),
                        },
                      ],
                })(

                  <Select disabled={!isEditable || isDisabled}>
                        <Select.Option value={null}><i>-{this.props.i18n.t("Not set")}-</i></Select.Option>
                        <Option key="azure_option" value="azure">
                            {this.props.i18n.t("NamespaceEditSamlConfig:Azure")}
                          </Option>
                        <Option key="ping_option" value="ping">
                            {this.props.i18n.t("NamespaceEditSamlConfig:Ping")}
                          </Option>
                      </Select>
                  )}
                  </div>
                </Form.Item>
              </Col>

              <Col lg={24}> <Form.Item
                label={this.props.i18n.t("NamespaceEditSamlConfig:Saml ID path in saml data")}
              >
                <div>

                  <div><p className={classes.grayComment}><i>{this.props.i18n.t(
                    "NamespaceEditSamlConfig: * Not required for default configurations with Azure or Ping IdP, but can be useful in custom configurations, or for connecting other saml IdPs. This path should point to a unique ID in the data returned by the saml IdP on login. Ex: \"saml_subject.0\" for PING"
                  )}</i></p></div>

                  <div><p className={classes.grayComment}><i>{this.props.i18n.t(
                    "NamespaceEditSamlConfig: (Format: Path string with '.' delimiters Ex: 'path.to.place.0', or a CSV of strings ignoring '.' delimiters Ex: 'path,http://one.signle_url.com,in_url,place,0')"
                  )}</i></p></div>
                  {getFieldDecorator("saml_id_path", {
                    initialValue: get(configData, "saml_id_path", null),
                  })(
                    <Input
                      disabled={!isEditable || isDisabled}
                      placeholder={this.props.i18n.t(
                        "NamespaceEditSamlConfig:SAML ID Path"
                      )}
                      allowClear
                    />
                  )}
                </div>
              </Form.Item> </Col>

              <Col md={12}> <label> <Form.Item
                label={this.props.i18n.t(
                  "NamespaceSamlConfigForm:Select Default role"
                )}
              >
                {getFieldDecorator("default_role_id", {
                  rules: [
                    {
                      required: false,
                      message: this.props.i18n.t("Required"),
                    },
                  ],
                  initialValue: get(configData, "default_role_id"),
                })(
                      <Select disabled={!isEditable || isDisabled}>
                        <Select.Option value={null}><i>-{this.props.i18n.t("Not set")}-</i></Select.Option>
                        {this.props.roles.map(({ id, name }) => (
                          <Option key={id} value={id}>
                            {name}
                          </Option>
                        ))}
                      </Select>
                    )}
                  </Form.Item>
                </label>
              </Col>

              <Col md={12}>
                <label>
                  <Form.Item
                    label={this.props.i18n.t(
                      "NamespaceSamlConfigForm:Select Default Site"
                    )}
                  >
                    {getFieldDecorator("default_site_id", {
                      rules: [
                        {
                          required: false,
                          message: this.props.i18n.t("Required"),
                        },
                      ],
                      initialValue: get(configData, "default_site_id"),
                    })(
                      <Select disabled={!isEditable || isDisabled}>
                        <Select.Option value={null}><i>-{this.props.i18n.t("Not set")}-</i></Select.Option>
                        {this.props.sites.map(({ id, name }) => (
                          <Option key={id} value={id}>
                            {name}
                          </Option>
                        ))}
                      </Select>
                    )}
                  </Form.Item>
                </label>
              </Col>
            </Row>
            <Row gutter={8}>
              <Col sm={24}>
                <div className={classes.drugDosageGroup}>
                  <div style={{margin: "5px 12px"}}>
                    <b>Fields</b>
                    <div><p className={classes.grayComment}><b><i>{this.props.i18n.t(
                      "NamespaceEditSamlConfig:The fields provided by the Identity Provider will be mapped to the DCTMS (SP) fields. Correctly mapping the \"email\" dctms field  is REQUIRED for saml authentication to work."
                    )}</i></b></p></div>
                    <div><p className={classes.grayComment}><i>{this.props.i18n.t(
                      "NamespaceEditSamlConfig:Roles can be mapped via the DCTMS field: \"roles\"; and SAML field containing: [\"Role name site 01\", ...] (or a csv string that splits into an array)"
                    )}</i></p></div>
                    <div><p className={classes.grayComment}><i>{this.props.i18n.t(
                      "NamespaceEditSamlConfig:Alternatively a single role or site can be mapped via the \"dctms_role\" and \"dctms_site_id\" mapped to SAML fields with string values."
                    )}</i></p></div>
                    <div><p className={classes.grayComment}><i>{this.props.i18n.t(
                      "NamespaceEditSamlConfig:If no roles mapping is provided or an error happens during role parsing then the DEFAULT roles and site will be used." +
                      " It is advised to have minimal permissions for the DEFAULT role in a production environment. Ideally the default role should have only the user " +
                      "profile permissions and the users authenticated with this role will be moderated by the project staff later and assigned the correct roles."
                    )}</i></p></div>

                    {get(configData, "type_name", null) === 'azure' && (
                      <div><p className={classes.grayComment}><i>{this.props.i18n.t(
                        "NamespaceEditSamlConfig:Link up the desired Attributes & Claims from the Azure Enterprise app Single Sign-on set up (config step 2)."
                      )}</i></p></div>)}

                  </div>
                  {samlSettingsKeys.map((key, i) =>
                    key ? (
                      <div className={classes.itemGroup} key={i}>
                        <Row gutter={8}> <Col lg={10}>
                          <div>
                            <Form.Item
                              label={this.props.i18n.t(
                                  "NamespaceEditSamlConfig:DCTMS Field (SP)"
                                )}
                              >
                                {getFieldDecorator(
                                  `samlGroup[${key}].attributeName`,
                                  {
                                    initialValue: get(
                                      this.state,
                                      `samlSettingsValues[${key}].attributeName`,
                                      null
                                    ),
                                    rules: [
                                      {
                                        required: true,
                                        message: this.props.i18n.t("Required"),
                                      },
                                    ],
                                  }
                                )(
                                  <Input
                                    disabled={!isEditable || isDisabled}
                                    placeholder={this.props.i18n.t(
                                      "NamespaceEditSamlConfig:Attribute"
                                    )}
                                    allowClear
                                  />
                                )}
                              </Form.Item>
                            </div>
                          </Col>

                          <Col lg={10}>
                            <div>
                              <Form.Item
                                label={this.props.i18n.t(
                                  "NamespaceEditSamlConfig:SAML Field (IdP)"
                                )}
                              >
                                {getFieldDecorator(
                                  `samlGroup[${key}].attributeValue`,
                                  {
                                    initialValue: get(
                                      this.state,
                                      `samlSettingsValues[${key}].attributeValue`,
                                      null
                                    ),
                                    rules: [
                                      {
                                        required: true,
                                        message: this.props.i18n.t("Required"),
                                      },
                                    ],
                                  }
                                )(
                                  <Input
                                    disabled={!isEditable || isDisabled}
                                    placeholder={this.props.i18n.t(
                                      "NamespaceEditSamlConfig:Value"
                                    )}
                                    allowClear
                                  />
                                )}
                              </Form.Item>
                            </div>
                          </Col>

                          {isEditable && (
                            <Col lg={4}>
                              {samlSettingsKeys.length > 1 && (
                                <Icon
                                  style={{
                                    margin: "34px 0 5px 10px",
                                    color: "#f00",
                                  }}
                                  type="delete"
                                  onClick={() => {
                                    this.removeSamlGroup(key);
                                  }}
                                />
                              )}
                            </Col>
                          )}
                        </Row>
                      </div>
                    ) : null
                  )}

                  <p className={classes.addDrugDossageWrapper}>
                    <Button
                      disabled={!isEditable || isDisabled}
                      type="button"
                      size="small"
                      style={{ padding: "0.3rem" }}
                      onClick={this.addSamlGroup}
                    >
                      {this.props.i18n.t(
                        "NamespaceEditSamlConfig:Add Attribute"
                      )}
                    </Button>
                  </p>
                </div>
              </Col>
            </Row>

            <br />

            <Row gutter={8}>
              <Col sm={24}>
                <div className={classes.drugDosageGroup}>
                  <div style={{margin: "5px 12px"}}>
                    <b>Roles</b>
                    <div><p className={classes.grayComment}><b><i>{this.props.i18n.t(
                      "NamespaceEditSamlConfig:For saml authentication to work correctly either the default roel and site, or a valid role/site mapping needs to be configured. DCTMS roles are mapped by role name, with capitalization."
                    )}</i></b></p></div>
                    <div><p className={classes.grayComment}><i>{this.props.i18n.t(
                      "NamespaceEditSamlConfig:DCTMS roles are mapped by role name, with capitalization Ex: \"Full Access\"."
                    )}</i></p></div>
                    <div><p className={classes.grayComment}><i>{this.props.i18n.t(
                      "NamespaceEditSamlConfig:Roles NOT present in this mapping will be IGNORED event if the role names coming from the IdP match the role names in DCTMS."
                    )}</i></p></div>
                  </div>
                  {samlRoleKeys.map((key, i) =>
                    key ? (
                      <div className={classes.itemGroup} key={i}>
                        <Row gutter={8}> <Col lg={10}>
                          <div>
                            <Form.Item
                              label={this.props.i18n.t(
                                "NamespaceEditSamlConfig:DCTMS Role name"
                                )}
                              >
                                {getFieldDecorator(
                                  `samlRoleGroup[${key}].attributeName`,
                                  {
                                    initialValue: get(
                                      this.state,
                                      `samlRoleValues[${key}].attributeName`,
                                      null
                                    ),
                                    rules: [
                                      {
                                        required: true,
                                        message: this.props.i18n.t("Required"),
                                      },
                                    ],
                                  }
                                )(
                                  <Input
                                    disabled={!isEditable || isDisabled}
                                    placeholder={this.props.i18n.t(
                                      "NamespaceEditSamlConfig:Attribute"
                                    )}
                                    allowClear
                                  />
                                )}
                              </Form.Item>
                            </div>
                          </Col>

                          <Col lg={10}>
                            <div>
                              <Form.Item
                                label={this.props.i18n.t(
                                  "NamespaceEditSamlConfig:Role in SAML"
                                )}
                              >
                                {getFieldDecorator(
                                  `samlRoleGroup[${key}].attributeValue`,
                                  {
                                    initialValue: get(
                                      this.state,
                                      `samlRoleValues[${key}].attributeValue`,
                                      null
                                    ),
                                    rules: [
                                      {
                                        required: true,
                                        message: this.props.i18n.t("Required"),
                                      },
                                    ],
                                  }
                                )(
                                  <Input
                                    disabled={!isEditable || isDisabled}
                                    placeholder={this.props.i18n.t(
                                      "NamespaceEditSamlConfig:Value"
                                    )}
                                    allowClear
                                  />
                                )}
                              </Form.Item>
                            </div>
                          </Col>

                          {isEditable && (
                            <Col lg={4}>
                              {samlSettingsKeys.length > 1 && (
                                <Icon
                                  style={{
                                    margin: "34px 0 5px 10px",
                                    color: "#f00",
                                  }}
                                  type="delete"
                                  onClick={() => {
                                    this.removeSamlRoleGroup(key);
                                  }}
                                />
                              )}
                            </Col>
                          )}
                        </Row>
                      </div>
                    ) : null
                  )}

                  <p className={classes.addDrugDossageWrapper}>
                    <Button
                      disabled={!isEditable || isDisabled}
                      type="button"
                      size="small"
                      style={{ padding: "0.3rem" }}
                      onClick={this.addSamlRoleGroup}
                    >
                      {this.props.i18n.t(
                        "NamespaceEditSamlConfig:Add Attribute"
                      )}
                    </Button>
                  </p>
                </div>
              </Col>
            </Row>
          </div>

          <Row gutter={8}>
            {errorMessage && (
              <Col span={24}>
                <Alert message={errorMessage} type="error" />
              </Col>
            )}
            <Col span={24}>
              <Button
                disabled={!isEditable || isDisabled}
                type="primary"
                size="large"
                htmlType="submit"
                loading={isLoading}
              >
                {this.props.i18n.t("Save")}
              </Button>
            </Col>
          </Row>
        </Form>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({});
const mapDispatchToProps = { logout };

export default Form.create({ name: "EditConfigForm" })(
  connect(mapStateToProps, mapDispatchToProps)(withNamespaces()(EditConfigForm))
);



// WEBPACK FOOTER //
// ./src/containers/SamlConfig/EditConfigForm.js